/**
 * A FEATURED CARD WITH NO PRICE SHIPS NO PRICE LINE (2026-10-26, Justin Bradford, Teams:
 * "The builder is adding 'From The' to the community modules", job 1040115, Auburn Meadows).
 *
 * Layne's Featured blocks render the price as its own paragraph, `{{PriceLabel}} {{Price}}`.
 * PriceLabel is an optional prefix the author types ("From", "From the"); Price is filled from
 * the plan feed or typed. When a card had a prefix but no price, the email printed the prefix
 * alone ("From the") under the specs, while the card in the panel showed nothing, because the
 * panel already hides a prefix with no price behind it.
 *
 * The rule, applied where the block is rendered:
 *   · no price → the whole price paragraph is removed, so no dangling prefix and no empty line;
 *   · and, for any markup where the two tokens are not alone in a paragraph, the prefix renders
 *     empty whenever the price is empty (see `priceLabelValue`).
 */

/** the block declares a Price field and this card has no price in it */
export function priceMissing(d: Record<string, unknown>, declared: Record<string, unknown>): boolean {
  if (!declared || !Object.prototype.hasOwnProperty.call(declared, "Price")) return false;
  return String(d.Price == null ? "" : d.Price).trim() === "";
}

const tokenOf = (declared: Record<string, { token?: string } | undefined>, k: string) =>
  (declared[k] && declared[k]!.token) || "{{" + k + "}}";
const esc = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** remove the paragraph that holds only the price tokens, when the price is empty */
export function dropEmptyPriceLine(html: string, d: Record<string, unknown>, declared: Record<string, { token?: string } | undefined>): string {
  if (!html || !priceMissing(d, declared as Record<string, unknown>)) return html;
  const label = esc(tokenOf(declared, "PriceLabel"));
  const price = esc(tokenOf(declared, "Price"));
  const re = new RegExp("<p\\b[^>]*>\\s*(?:" + label + "\\s*)?" + price + "\\s*</p>", "gi");
  return html.replace(re, "");
}

/** the value the PriceLabel token renders as: empty when there is no price behind it */
export function priceLabelValue(v: string, d: Record<string, unknown>, declared: Record<string, unknown>): string {
  return priceMissing(d, declared) ? "" : v;
}
